module.exports = __webpack_public_path__ + "img/20191107161942973.82a65435.jpg";